import React from "react";
import PropTypes from "prop-types";
import PaymentSelect from "@components/paymentSelect/index.jsx";
import {
	BettoFieldControl,
	BettoFieldLabel,
	BettoFieldRoot,
} from "../../shared/bettoPaymentFieldStyles";

export const BettoCurrencyField = ({
	label,
	labelTestId,
	selectTestId,
	selectedTextTestId,
	options,
	value,
	onSelect,
}) => (
	<BettoFieldRoot>
		<BettoFieldLabel data-testid={labelTestId}>{label}</BettoFieldLabel>
		<BettoFieldControl>
			<PaymentSelect
				data-testid={selectTestId}
				selected-text-data-testid={selectedTextTestId}
				options={options}
				value={value}
				handleSelect={onSelect}
			/>
		</BettoFieldControl>
	</BettoFieldRoot>
);

BettoCurrencyField.propTypes = {
	label: PropTypes.string.isRequired,
	labelTestId: PropTypes.string,
	selectTestId: PropTypes.string,
	selectedTextTestId: PropTypes.string,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.number.isRequired,
			label: PropTypes.string.isRequired,
		})
	).isRequired,
	value: PropTypes.number,
	onSelect: PropTypes.func.isRequired,
};

BettoCurrencyField.defaultProps = {
	labelTestId: undefined,
	selectTestId: undefined,
	selectedTextTestId: undefined,
	value: undefined,
};
